module.exports = __webpack_public_path__ + "static/mobile_phone-1eef9329b3ee4f1bffe9dcdd19ee0d73.jpg";